import { cdnBaseUrl } from './constants.js';
// GET AWS ASSETS URL BY GIVING ASSET NAME AND FOLDER NAME
export const getAwsAssets = (assetName, folderName = "contentStoreCommon") => {
  const baseURL = `https://${cdnBaseUrl}-cloudn.classplus.co`;
  const webPrefix = "web";
  const courseWebviewPrefix = "courseWebview";

  // return `/api/proxyimage?url=${encodeURIComponent(`${baseURL}/${courseWebviewPrefix}/${folderName}/${assetName}`)}`;
  return `${baseURL}/${webPrefix}/${courseWebviewPrefix}${
    folderName ? `/${folderName}` : ""
  }/${assetName} `;
};

// GET HSL COLOR FROM A STRING (basically can be used for Avatars)
export const getColorFromString = (name, s = 50, l = 80) => {
  let hasher = 0;
  for (let i = 0; i < name.length; i++) {
    hasher = name.charCodeAt(i) + ((hasher << 5) - hasher);
  }
  let h = hasher % 360;
  return "hsl(" + h + ", " + s + "%, " + l + "%)";
};

// FUNCTION TO HIT HAPTIC FEEDBACK ON MOBILE DEVICE
// time in ms B DEFAULT 40
export const hitHapticFeedback = (time = 40) => {
  window.navigator.vibrate && window.navigator.vibrate(time);
  // hitDeeplinkExecutedV2(null, JSON.stringify({
  //   screen: COMMON_DEEPLINK_ACTIONS.UTIL_HIT_HAPTIC_FEEDBACK,
  //   paramOne: `${ time } `
  // }), false)
};



// COMMON UTIL FOR GETTING REDUX ACTION BY TYPE AND PAYLOAD
export const getActionObject = (type, payload) => {
  return {
    type,
    payload,
  };
};

export const validateEmail = (email) => {
  if (email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  return false;
};

export function validateCity(city) {
  if (city) {
    var re = /[^a-zA-Z0-9 ]/;
    return !re.test(city);
  }
  return true;
}

export const addTokenInUrl = (str, token) => {
  let splitStr = str.split("{hash}");
  splitStr.splice(1, 0, token);
  let newStr = splitStr.join("");
  return newStr;
};
